import React from "react";
import { formatDate } from "../../components/helpers/formatDate";

/**
 * A mobile rental contract card.
 * @param {object} contract - The rental contract data
 * @param {string|number} entityID - The contact or company ID to filter participant roles
 * @param {string} entityType - "contact" or "company"
 * @param {function} onClick - Click handler
 */
export default function MobileRentalItem({ contract, entityID, entityType = "contact", onClick }) {
  const unitNames = Array.isArray(contract.units) 
    ? contract.units.map(u => u.unit_name).filter(Boolean) 
    : [];
  
  const participantTypes = Array.from(new Set(
    (Array.isArray(contract.participants) ? contract.participants : [])
      .filter(p => {
        if (entityType === "contact") {
          return p?.contact?.id == entityID;
        }
        return p?.company?.id == entityID;
      })
      .map(p => p?.participant_type)
      .filter(Boolean)
  ));

  return (
    <div className="mobile-rental-item" onClick={onClick}>
      <div className="mobile-rental-item__header">
        <span>Contract #{contract.id}</span>
        <span className={`mobile-rental-item__status ${contract.active ? 'active' : ''}`}>
          {contract.active ? 'Active' : 'Inactive'}
        </span>
      </div>
      <div className="mobile-rental-item__type">
        {contract.rental_type || "N/A"} • Role: {participantTypes.join(', ') || 'N/A'}
      </div>
      {unitNames.length > 0 && (
        <div className="mobile-property-item__units">
          {unitNames.map((name, idx) => (
            <span key={idx} className="mobile-unit-tag">{name}</span>
          ))}
        </div>
      )}
      <div className="mobile-rental-item__dates">
        {contract.start_date ? formatDate(contract.start_date) : "N/A"}
        {contract.end_date && ` → ${formatDate(contract.end_date)}`}
      </div>
    </div>
  );
}

